/**
 * Grade 2×2 do slide de investimento (Home, Categoria, PDP, Páginas adicionais).
 * Usado em Layout Personalizado e E-commerce.
 */
export const LAYOUT_GRID_CATEGORY_COORDS = {
  Home: { x: 38, y: 10 },
  Categoria: { x: 68, y: 10 },
  'Detalhes do Produto': { x: 38, y: 40 },
  'Páginas Adicionais': { x: 68, y: 40 },
} as const

export const LAYOUT_GRID_PROPOSAL_LAYOUT = {
  leftBlockWidth: 35,
  titleY: 7.1,
  projectTypeY: 16.4,
  descriptionY: 27.3,
  bonusY: 48,
  priceY: 82.8,
  paymentY: 90,
  loyaltyY: 74.8,
  planTitleY: 2.7,
  serviceBlockX: 38,
  serviceBlockGap: 68,
  serviceBlockStartY: 10,
  categoryCoords: { ...LAYOUT_GRID_CATEGORY_COORDS },
} as const
